<div class="select-dropdown">
  <mat-form-field floatLabel="never" class="" appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      disableOptionCentering
      panelClass="groupdrop-position"
      #select
      placeholder="groups"
      [formControl]="groupControl"
      multiple
      panelWidth
    >
      <mat-select-trigger>
        {{ groupControl.value && groupControl.value.length > 0 ? groupControl.value[0].value : '' }}
        <span *ngIf="groupControl.value?.length > 1"> (+{{ groupControl.value.length - 1 }}) </span>
      </mat-select-trigger>
      <mat-option
        class="checkbox-customization"
        *ngFor="let userGroup of userGroupOptions"
        [value]="userGroup"
        [matTooltip]="userGroup.desc"
        >{{ userGroup.value }}</mat-option
      >
    </mat-select>
  </mat-form-field>
</div>
